module.exports = __webpack_public_path__ + "img/supervised-user-circle-24-px-1.3ff9b9df.svg";